<app-network-status-badge />

<div class="auth-wrapper">

  <!-- Brand -->
  <div class="brand">
    <img class="brand-logo" src="assets/Agos-logo-blue.png" alt="AGOS" />
    @if (runtime.IsDesktopApplication) {
      <p class="brand-subtitle">Weight &amp; Balance FAT Client</p>
    } @else {
      <p class="brand-subtitle">Weight &amp; Balance System</p>
    }
  </div>

  @if (showQrSetup && !isOnline()) {
    <div class="network-hint">
      <i class="bi bi-wifi-off"></i>
      <span><strong>You're offline.</strong> Reconnect to complete authentication.</span>
    </div>
  }

  <div class="auth-card">

    <!-- Header -->
    <h2 class="title">Authentication</h2>
    <p class="subtitle">
      @if (showQrSetup) {
        Scan the QR and enter 6 digit code
      } @else {
        Enter 6 digit code from your authenticator
      }
    </p>

    @if (totpSetup?.issuerName) {
      <div class="account-card">
        <div class="account-icon">
          <i class="bi bi-display"></i>
        </div>
        <div class="account-info">
          <span class="account-label">Account Name</span>
          <span class="account-name">{{ totpSetup?.issuerName }}</span>
          @if (showQrSetup) {
            <p class="account-hint">This is the name that will appear in your authenticator app after scanning the QR code.</p>
          } @else {
            <p class="account-hint">Use the code shown under this name in your authenticator app.</p>
          }
        </div>
      </div>
    }

    <form (keydown.enter)="onEnterKey($event)">
      <div class="auth-form">
        @if (showQrSetup) {
          <div class="qr-wrapper">
            <div class="qr-container">
              <img [src]="totpSetup?.qrCodeImageUri" alt="QR Code" class="qr-code" height="120" width="120">
            </div>
            <p class="qr-caption">
              <i class="bi bi-phone"></i>
              Scan with authenticator
            </p>
          </div>
        }

        <div class="otp-container">
          <app-segmented-input
            [(ngModel)]="otpCode"
            name="otpCode"
            [segments]="6"
            [segmentLength]="1"
            separator=" "
            pattern="numeric"
            [autofocus]="true"
            [keepFocus]="true"
          />

          <button class="primary-btn" type="button" [disabled]="!isCodeComplete || loading || (showQrSetup && !isOnline())" (click)="onAuthenticated()">
            Verify
          </button>
        </div>
      </div>

      @if (showQrSetup && totpSetup?.secret) {
        <div class="secret-fallback">
          <button type="button" class="secret-toggle" (click)="toggleSecret()">
            <i class="bi" [class.bi-chevron-right]="!secretVisible" [class.bi-chevron-down]="secretVisible"></i>
            Can't scan the QR? Enter Secret Key manually
          </button>

          @if (secretVisible) {
            <div class="secret-panel">
              <p class="secret-hint">Add this secret key in your authenticator app.</p>
              <div class="secret-key-row">
                <code class="secret-key">{{ formattedSecret }}</code>
                <button
                  type="button"
                  class="copy-btn"
                  [class.copied]="secretCopied"
                  (click)="copySecret()"
                  [attr.aria-label]="secretCopied ? 'Copied' : 'Copy secret key'"
                >
                  <i class="bi" [class.bi-copy]="!secretCopied" [class.bi-check2]="secretCopied"></i>
                  {{ secretCopied ? 'Copied' : '' }}
                </button>
              </div>
            </div>
          }
        </div>
      }
    </form>
  </div>
</div>
